import React from "react";
import styles from "./confirmation.module.scss";
import { useConfirmationPageLoad } from "./useAnalyticsHooks";

export const metadata = {
  title: `Price promise refund request submitted | Customer Services`,
  description: `Learn about our payment options. Find out how to use gift cards and vouchers, check your gift card balance, and get a VAT receipt for your order.`,
};

function PricePromiseFormSubmitted() {
  useConfirmationPageLoad();

  return (
    <>
      <div className={styles["grid-container"]}>
        <h1>We’ve received your request</h1>
        <p>
          We’ll now check to see if you’re due a price promise refund. We’ll contact you by email and we aim to respond
          within 48 hours.
        </p>
        <p>
          If you are eligible, we’ll process your refund using the same payment method you used for your original
          purchase. If for any reason we find you’re not due a refund, we’ll email you to let you know the reason.
        </p>
      </div>
    </>
  );
}

PricePromiseFormSubmitted.metadata = metadata;

export default PricePromiseFormSubmitted;
